import { Box, Button, Typography } from '@mui/material';

interface Props {
    message: string;
    onRetry: () => void;
    isRetrying?: boolean;
}

export default function ProspectDetailsErrorPage({ message, onRetry, isRetrying }: Props) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 320,
                p: 3,
                gap: 2,
            }}
        >
            <Typography variant="body1" color="text.secondary" textAlign="center">
                {message}
            </Typography>
            <Button variant="outlined" onClick={onRetry} disabled={isRetrying}>
                Retry
            </Button>
        </Box>
    );
}
